import { NgForm } from '@angular/forms';
import { Component, Input } from '@angular/core';

import { AuthMethodsService } from '../auth-methods/auth-methods.service';
import { ForgotPswProps } from './forgot-password.model';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.page.html',
  styleUrls: ['./forgot-password.page.scss'],
})
export class ForgotPasswordPage {

  private _forgotPswProps: ForgotPswProps = {
    emailInvalid: 'Enter a valid email',
    emailRequired: 'Email is required',
    login: 'Login',
    sendPswReset: 'Send Password reset email',
  }
  @Input() set forgotPswProps(value: ForgotPswProps) {
    this._forgotPswProps = { ...this.forgotPswProps, ...value };
  }
  get forgotPswProps(): ForgotPswProps {
    return this._forgotPswProps;
  }

  constructor(private readonly authMethodsService: AuthMethodsService) {
    this.authMethodsService.translations?.subscribe(translations => {
      this.forgotPswProps = { ...this.forgotPswProps, ...translations.forgotPassword || {} };
    });
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(forgotPassword: NgForm): void {
    this.authMethodsService.forgotPageService?.onSubmit(forgotPassword);
  }
}
